import React, { useState, useMemo, useEffect } from "react";
import styles from "./ManageUser.module.scss";
import Stepper from "./stepper/Stepper";
import StepAccount from "./steps/stepAccount/StepAccount";
import StepSubscription from "./steps/stepSubscription/StepSubscription";
import StepCabine from "./steps/stepCabine/StepCabine";
import StepSummary from "./steps/stepSummary/StepSummary";

const INITIAL_USER_DATA = {
  login: "",
  name: "",
  lastName: "",
  email: "",
  password: "",
  subscription: "",
  plan: "",
  subid: "",
  licenses: [],
  cabine: "",
  typeCabine: "",
  group: "",
  groupName: "",
  createdAt: null,
  isValid: false,
};

const ManageUser = ({ onDirtyChange }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [triggerValidation, setTriggerValidation] = useState(0);
  const [triggerSave, setTriggerSave] = useState(0);
  const [hasConflict, setHasConflict] = useState(false);
  const [isStepValid, setIsStepValid] = useState(false);

  const [userData, setUserData] = useState({ ...INITIAL_USER_DATA });

  const updateUserData = (newData) => {
    setUserData((prevData) => ({
      ...prevData,
      ...newData,
    }));
  };

  const isDirty = useMemo(() => {
    const fields = ["login", "name", "lastName", "email", "password", "subscription", "plan", "subid"];
    return (
      fields.some((f) => (userData[f] || "") !== (INITIAL_USER_DATA[f] || "")) ||
      (userData.licenses || []).length > 0 ||
      (Array.isArray(userData.cabines) && userData.cabines.length > 0)
    );
  }, [userData]);

  useEffect(() => {
    if (onDirtyChange) onDirtyChange(isDirty);
  }, [isDirty, onDirtyChange]);

  useEffect(() => {
    if (!isDirty) return;
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isDirty]);

  const steps = ["Compte", "Abonnement", "Cabine", "Résumé"];

  return (
    <div className={styles.container}>
      <Stepper currentStep={currentStep} steps={steps} />

      <div className={styles.content}>
        {currentStep === 1 && (
          <StepAccount
            userData={userData}
            updateUserData={updateUserData}
            triggerValidation={triggerValidation}
            onConflictChange={setHasConflict}
            onValidChange={setIsStepValid}
          />
        )}
        {currentStep === 2 && (
          <StepSubscription
            userData={userData}
            updateUserData={updateUserData}
            onNext={() => setCurrentStep(3)}
            onPrev={() => setCurrentStep(1)}
            onValidChange={setIsStepValid}
          />
        )}

        {currentStep === 3 && (
          <StepCabine
            userData={userData}
            updateUserData={updateUserData}
            onNext={() => setCurrentStep(4)}
            onPrev={() => setCurrentStep(2)}
            onValidChange={setIsStepValid}
          />
        )}
        {currentStep === 4 && (
          <StepSummary
            userData={userData}
            updateUserData={updateUserData}
            onPrev={() => setCurrentStep(3)}
            triggerSave={triggerSave}
            onSave={() => {
              console.log("Données finales à sauvegarder:", userData);
              // Appel API backend
            }}
          />
        )}

        {/* Boutons de navigation */}
        <div className={styles.navigationButtons}>
          {currentStep > 1 && (
            <button
              type="button"
              onClick={() => setCurrentStep(Math.max(1, currentStep - 1))}
              className={styles.btnSecondary}
            >
              Précédent
            </button>
          )}
          {currentStep < steps.length && (
            <button
              type="button"
              onClick={() => setCurrentStep(Math.min(steps.length, currentStep + 1))}
              className={styles.btnPrimary}
              disabled={!isStepValid || (currentStep === 1 && hasConflict)}
            >
              Suivant
            </button>
          )}
          {currentStep === steps.length && (
            <button
              type="button"
              onClick={() => setTriggerSave((prev) => prev + 1)}
              className={styles.btnPrimary}
            >
              Sauvegarder
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageUser;
